const popupBlock = (editor, options) => {
  const popupBlockOptions = options.blocks.popup;
  const { name, label, category } = popupBlockOptions;

  const popupStyles = options.components.popup.style;

  const bm = editor.BlockManager;

  bm.add(name, {
    media: `<i class="fa fa-code"></i>`,
    label: `${label}`,
    category: category,
    content: {
      type: name,
      style: popupStyles
    }
  });
};

export default popupBlock;
